// extracted by mini-css-extract-plugin
export var heroContainer = "styles-module--heroContainer--WmjPH";
export var textBlock = "styles-module--textBlock--vfD9K";
export var ribbon = "styles-module--ribbon--8rzyu";
export var info = "styles-module--info--YkL7-";
export var rightSection = "styles-module--rightSection--uwd1H";